import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';

export const BenefitsCardBox = styled(Box, {
  dynamic: ({ cssProps: { displayCarousel } }) => ({
    marginBottom: displayCarousel ? '' : '16px',
  }),
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  position: 'relative',
  flex: '1 0 0',
  padding: '0px',
});

export const LinkContainer = styled('div', {
  display: 'flex',
  margin: '4px 0',
  zIndex: '2',
  '@screen < $sm': {
    marginBottom: '0px',
  },
});

export const IconContainer = styled('div', {
  position: 'relative',
  variants: {
    isGeha: {
      true: {
        right: '12px',
      },
      false: {
        right: '4px',
      },
    },
  },
});

export const slideContainerStyle = {
  'abyss-slide-content-wrapper': {
    padding: '0',
    visibility: 'visible',
    '> div': {
      height: '100%',
    },
  },
};

export const carouselStyle = {
  'abyss-carousel-root': {
    display: 'flex',
    flexWrap: 'wrap',
    '@screen >= $sm': {
      width: '100%',
      marginTop: '16px',
    },
    '@screen < $sm': {
      width: '100%',
      marginTop: '12px',
    },
  },
  'abyss-carousel-swiper-container': {
    display: 'flex',
    marginBottom: '12px',
    width: '100%',
    willChange: 'transform',
    zIndex: 0,
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    width: '384px',
    gap: '24px',
    height: 'auto',
    '@screen < $sm': {
      width: '311px',
      gap: '24px',
    },
  },
  'abyss-carousel-minimal-controls': {
    marginTop: '0px',
    padding: '0px',
    height: '20px',
    marginBottom: '20px',
    width: '100%',
    '@screen < $sm': {
      marginBottom: 0,
    },
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
  },
  'abyss-carousel-minimal-nav-icon-right': {
    color:
      'var(--abyss-psx-parcel-colors-carousel-color-background-bullets-isActive) !important',
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    color:
      'var(--abyss-psx-parcel-colors-carousel-color-background-bullets-isActive) !important',
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
};

export const GridColStyle = {
  padding: '12px 12px 0 12px',
  '@screen < $sm': {
    padding: '0px',
  },
};
